import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { LocalStoreManager } from '../services/local-store-manager.service';
import { ShareDataService } from 'src/providers/sharedata.service';
import { ShareModel } from 'src/models/share.model';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApiService } from 'src/services/rest-api.service';
import { TableModel } from 'src/models/table.model';
import { UserIdleService } from 'angular-user-idle';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-20%)', opacity: 0 }),
        animate('250ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('250ms', style({ transform: 'translateY(-20%)', opacity: 0 }))
      ])
    ])
  ]
})
export class AppComponent implements OnInit {
  title = 'SepidzDigitalMenu';

  isToggledUppercase = false;
  hideComponents = false;
  hideGuides = false;
  hideCDK = false;
  selectedthem = 2;
  // isrtl:string= 'rtl';
  isTestScreen = false;
  constructor(
    private breakObserver: BreakpointObserver,
    public translate: TranslateService,
    private storageManager: LocalStoreManager,
    public share: ShareDataService,
    private router: Router,
    private spinner: NgxUiLoaderService,
    private api: RestApiService<any>,
    private userIdle: UserIdleService,
    private http: HttpClient

    // private auth:AuthService
  ) {
    // this.setTheme(this.storageManager.getData('Theme'));
    this.share.getSetting();
    this.storageManager.initialiseStorageSyncListener();
    this.share.goodsGroupList();


  }
  private get targetElement(): HTMLElement {
    let elem: HTMLElement;
    return elem;
  }

  // get isMobile() {
  //   if (this.breakObserver.isMatched("(max-width: 599px)")) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // changeTitle(title: string) {
  //   this.title = title;
  // }
  // toggleGuides() {
  //   this.hideGuides = !this.hideGuides;
  // }
  // toggleComponents() {
  //   this.hideComponents = !this.hideComponents;
  // }
  // toggleUppercase() {
  //   this.isToggledUppercase = !this.isToggledUppercase;
  //   if (this.isToggledUppercase) {
  //     document.body.classList.add("button-uppercase");
  //     window.localStorage.setItem("isToggledUppercase", JSON.stringify(true));
  //   } else {
  //     document.body.classList.remove("button-uppercase");
  //     window.localStorage.setItem("isToggledUppercase", JSON.stringify(false));
  //   }
  // }
  setLanguage(lan: string) {
    this.share.sharemodel.language = (!lan) ? 'FA' : 'EN';
    // let defaultLanguage = this.translate.getDefaultLang();
    this.translate.setDefaultLang(lan);
    this.translate.use(lan);
    this.storageManager.savePermanentData(lan, 'Language');
    switch (lan) {
      case 'FA': {
        this.share.sharemodel.isrtl = true;
        break;
      }
      case 'EN': {
        this.share.sharemodel.isrtl = false;
        break;
      }
      default: {
        this.translate.setDefaultLang('FA');
        this.translate.use('FA');
        this.share.sharemodel.isrtl = true;
        break;
      }
    }
  }
  go(url: string) {
    // this.spinner.start();
    this.router.navigate([url]);
    // this.spinner.stopAll();
  }
  ngOnInit() {
    this.share.sharemodel = new ShareModel();
    this.share.sharemodel.language = this.storageManager.getData(
      'Language'
    );
    switch (this.storageManager.getData('Language')) {
      case 'FA': {
        this.translate.setDefaultLang('EN');
        this.translate.use('FA');
        this.share.sharemodel.isrtl = true;
        this.share.sharemodel.language = 'FA';

        break;
      }
      case 'EN': {
        this.translate.setDefaultLang('FA');
        this.translate.use('EN');
        this.share.sharemodel.isrtl = false;
        this.share.sharemodel.language = 'FA';

        break;
      }
      default: {
        this.translate.setDefaultLang('EN');
        this.translate.use('FA');
        this.share.sharemodel.isrtl = true;
        this.share.sharemodel.language = 'FA';

        break;
      }
    }

    if (document.body.classList.contains('button-uppercase')) {
      this.isToggledUppercase = true;
    } else if (window.localStorage.getItem('isToggledUppercase')) {
      this.isToggledUppercase = JSON.parse(
        window.localStorage.getItem('isToggledUppercase')
      );
    }
    // this.userIdle.startWatching();
    // // Start watching when user idle is starting.
    // this.userIdle.onTimerStart().subscribe(count => console.log(count));

    // // Start watch when time is up.
    // this.userIdle.onTimeout().subscribe(() => console.log('Time is up!'));
  }
  getTableList() {
    this.api.getEntity<TableModel[]>('AllTables').subscribe(res => {
      this.share.tableList = res;
    });
  }
  // @HostListener('click', ['$event'])
  // onClick(event: MouseEvent) {
  //     this.userIdle.stopTimer();
  // }
  // @HostListener('document:keydown', ['$event'])
  // onKeydownHandler(event: KeyboardEvent) {
  //     this.userIdle.stopTimer();
  // }
}
